<template>
    <div>
        <DamageClaim
            :claim="claim"
            :classification_style="classification_style"
            :participant_type="participant.type"
          />
    </div>
</template>

<script>
import DamageClaim from "@/components/Lead/DamageClaim.vue";

export default {
    components: {
        DamageClaim
    },

    data() {
        return {
            claim: {},
            classification_style: null,
            participant: {}
        }
    }
}
</script>